import { handlePaginatedData } from '../services/DataHelperFunctions';
import {
  handleApiErrorWithFallback,
  handleError,
  handleSuccess,
  getDefaultPagination,
} from './HttpUtil';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import type { Dispatch } from '@reduxjs/toolkit';
import { IAPIKeyRequest } from '../../types/IApiTypes';
import { IApiKey } from '../../types';

export const ApiKeyApi = {
  getApiKeys: async (action: IAPIKeyRequest, dispatch: Dispatch) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    try {
      return await AxiosClient.post(`/apikey/v1/read?${queryParams}`, {}).then((response) => {
        return handlePaginatedData(response, action);
      });
    } catch (err) {
      return handleApiErrorWithFallback(
        dispatch,
        err,
        { page: action.page, searchKey: action.searchCode, skipUpdate: action.skipUpdate },
        EAction.Read,
        EApiType.ApiKey
      );
    }
  },

  createApiKey: (action: { request: IApiKey }, dispatch: Dispatch) => {
    return AxiosClient.post('/apikey/v1/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  updateApiKey: (action: { request: IApiKey }, dispatch: Dispatch) => {
    return AxiosClient.post('/apikey/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  deleteApiKeys: (action: { request: { ids: string[] } }, dispatch: Dispatch) => {
    return AxiosClient.post('/apikey/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getServiceUsers: (dispatch: Dispatch) => {
    return AxiosClient.post('/user/v1/service/read', [])
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  //Get the Configit Property list
  getConfigitPropertyList: (dispatch: Dispatch) => {
    return AxiosClient.get('/ace/library/v1/properties/read')
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  //Get the PDM Property list
  getPdmPropertyList: (dispatch: Dispatch) => {
    const queryParams = getDefaultPagination();
    return AxiosClient.post('/property/v1/read?' + queryParams, {})
      .then((response) => {
        return {
          data: response.data.properties,
        };
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getPrivileges: (dispatch: Dispatch) => {
    return AxiosClient.get('/privilege/v1/read/all')
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },
};
